module.exports = "<p>[# connection-error]\n无法获取到全节点的 websocket 连接</p>\n<p>Possible reasons: TODO</p>\n<ul>\n<li>reason #1</li>\n<li>reason #2</li>\n</ul>\n";